export default __webpack_public_path__ + "static/media/julia5.53181d12.jpg";